import { render, staticRenderFns } from "./SidebarComp.vue?vue&type=template&id=45225b06&scoped=true&"
import script from "./SidebarComp.vue?vue&type=script&setup=true&lang=js&"
export * from "./SidebarComp.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SidebarComp.vue?vue&type=style&index=0&id=45225b06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45225b06",
  null
  
)

export default component.exports